<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-card shadow="never">
                    <!-- ///// filter pater //////  -->
                    <el-row :gutter="20">
                        <el-col class="text-md-left" :span="18">
                            <el-row class="filter-first-row">
                                <el-col class="searchCustomer">
                                    <el-input
                                        placeholder="รหัสลูกค้า, ชื่อลูกค้าหรืออีเมล"
                                        v-model="searchText"
                                        @input="onSearch()"
                                    >
                                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                    </el-input>
                                </el-col>
                                <el-col class="dropdown-filter" :span="10">
                                    <el-select
                                        v-model="filter.bank_id"
                                        @change="onSearch()"
                                        placeholder="Bank"
                                    >
                                        <el-option v-for="item in all_bank"
                                                   :key="item.id" :label="item.label" :value="item.id"></el-option>
                                    </el-select>
                                </el-col>
                            </el-row>
                        </el-col>
                        <!-- serach btn -->
                        <el-col :span="5" class="text-md-left">
                            <el-button type="primary" @click="onSearch()">ค้นหา</el-button>
                        </el-col>

                    </el-row>

                    <!-- ///// table part ////// -->
                    <el-row style="margin-top:10px">
                        <el-col class="text-md-left" :sm="24">
                            <el-table
                                v-loading="loadingTable"
                                :data="billingList"
                                stripe
                                :default-sort="{prop: 'createdAt', order: 'descending'}"
                                :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                                style="width: 100%"
                                ref="customerTable"
                                :row-key="getRowKey"
                                @selection-change="handleSelectionChange">
                                <el-table-column v-model="billingSelection" :reserve-selection="true" type="selection" align="center" width="55">
                                </el-table-column>

                                <el-table-column fixed prop="userCode" label="รหัสลูกค้า" width="120"></el-table-column>

                                <el-table-column fixed label="ชื่อลูกค้า" width="200">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ scope.row.firstName }} {{ scope.row.lastName }}
                                    </div>
                                </el-table-column>

                                <el-table-column label="Bank Name" width="150">
                                    <div class="text-md-left" slot-scope="scope">
                                        {{ getBankLabel(parseInt(scope.row.bankId)) }}
                                    </div>
                                </el-table-column>

                                <el-table-column fixed prop="bankAccountNumber" label="Account Number"></el-table-column>
                                <el-table-column fixed prop="bankAccountName" label="Account Name"></el-table-column>

                                <!--                      <el-table-column  label="Total Invoice" width="150">-->
                                <!--                          <div class="text-md-left" slot-scope="scope" >-->
                                <!--                              {{scope.row.totalInvoice}}-->
                                <!--                          </div>-->
                                <!--                      </el-table-column>-->

                                <!--                      <el-table-column  label="Total Paid" width="150">-->
                                <!--                          <div class="text-md-left" slot-scope="scope" >-->
                                <!--                            {{scope.row.totalPaid}}-->
                                <!--                          </div>-->
                                <!--                      </el-table-column>-->

                                <!--                      <el-table-column  label="Total Received" width="150">-->
                                <!--                          <div class="text-md-left" slot-scope="scope" >-->
                                <!--                            {{scope.row.totalReceived}}-->
                                <!--                          </div>-->
                                <!--                      </el-table-column>-->

                                <!--                      <el-table-column prop="potentialInactive"  label="Potential Inactive (create order)" width="120"></el-table-column>-->

                                <!-- <el-table-column fixed="right" label="จัดการ" width="150">
                                    <template slot-scope="scope">
                                        <el-button :key="scope.$index" size="small" icon="el-icon-edit" type="warning" plain @click="showUserDetail(scope.row)"></el-button>
                                        <el-button :key="scope.$index+'-shop'" size="small" icon="el-icon-document" type="info" plain @click="showShop(scope.row)"></el-button>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </el-col>
                        <el-col style="margin-top:10px;">
                            <el-pagination
                                @size-change="changeLimitPage"
                                @current-change="changeCurrentPage"
                                :current-page.sync="pagination.currentPage"
                                :page-sizes="pagination.pageSizes"
                                :page-size="10"
                                layout="prev, pager, next, sizes"
                                :total="pagination.allPage * pagination.limit">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import onlineOperationUtility from '@/mixins/onlineOperationUtility.js'
import { AllBank } from '@/components/Overview/FilterMaster.js'

const toDate = new Date()
const fromDate = '2015-01-01'
// var fromDate = new Date();
// fromDate = fromDate.setDate(fromDate.getDate()-90)

export default {
    name: 'BillingProfile',
    props: {},
    mixins: [onlineOperationUtility],
    data () {
        return {
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            searchText: '',
            filter: {
                bank_id: 0,
                subscription_status: 0,
                datePickTo: [this.$dayjs(fromDate).format('YYYY-MM-DD'), this.$dayjs(toDate).format('YYYY-MM-DD')]
            },
            all_bank: AllBank,
            loadingTable: false,
            billingList: [],
            billingSelection: null
        }
    },
    created () {
        this.fetchListBilling()
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchListBilling()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.fetchListBilling()
        },
        onSelectStatusFilter () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListBilling()
        },
        onSearch () {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.fetchListBilling()

            this.$refs.customerTable.clearSelection()
        },
        async fetchListBilling () {
            clearTimeout(this.timeoutSearch)
            this.timeoutSearch = setTimeout(async () => {
                this.loadingTable = true
                let param = {
                    bank_id: this.filter.bank_id,
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset
                }
                // let res = await fgApi.user.getbillingListOpt(param)
                let res = await fgApi.overview.getOverviewBillingProfile(param)
                if (res.success) {
                    if (this.searchText === param.search) {
                        this.billingList = res.data ? res.data : []
                        this.pagination.allPage = res.allPage
                    }
                }

                this.loadingTable = false
            }, 1000)
        },
        getBankLabel (id) {
            let hasCode = this.all_bank.filter((e) => { return e.id > 0 && e.id === id })
            if (hasCode.length > 0) {
                return hasCode[0].label
            } else {
                return '-'
            }
        },
        handleSelectionChange (val) {
            this.billingSelection = val
        },
        getRowKey (row) {
            return row.userId
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-first-row {
    display: flex;

    .searchCustomer {
        margin-right: 5px;
    }

    .dropdown-filter {
        width: 300px;
        margin-left: 5px;
    }
}

.filter-second-row {
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;

    .dropdown-filter {
        width: 300px;
        margin-right: 5px;
    }

    .date-filter {
        width: 600px;
    }
}

.table-column {
    min-width: 200px;
}

.btn-box {
    display: flex;
    justify-content: flex-end;

    .btn-export-box {
        margin-left: 16px;

        .btn-export {
            width: 90px;
            height: 40px;
        }
    }
}
</style>
